﻿import { BaseEditor } from './base-editor';
import { IForm } from '../interface/form';
import { AsyncValidatorFn, ValidatorFn } from '../types/validator-fn';
import { IEditor } from '../interface/editor';

export const CheckEditorTagName = 't-check';

export function createCheckEditor(form: IForm,
    name: string,
    element: HTMLElement,
    validators: ValidatorFn[],
    asyncValidators: AsyncValidatorFn[]): IEditor {
    return new TCheckEditor(form, name, element, validators, asyncValidators);
}

export class TCheckEditor extends BaseEditor<boolean> {
    inputElement: HTMLInputElement;

    constructor(
        form: IForm,
        name: string,
        element: HTMLElement,
        validators: ValidatorFn[],
        asyncValidators: AsyncValidatorFn[]) {
        super(form, name, element, validators, asyncValidators);

        const ie=  element.querySelector<HTMLInputElement>('input.form-check-input');
        if(!ie) {
            throw new Error(`Invalid DOM of field ${name}`);
        }

        this.inputElement =ie;
        this.inputElement.addEventListener('change', (ev: Event) => {
            this.reValidate();
            this.notifyChanges(this.value);
        });
        this.inputElement.addEventListener('click', (ev: Event) => {
            this.reValidate();
            this.notifyChanges(this.value);
        });
    }

    get value(): boolean {
        return this.inputElement.checked;
    }
    set value(value: boolean) {
        this.inputElement.checked = value;
    }

    setDisabled(disabled: boolean): void {
        this.inputElement.disabled = disabled;
        this.setDisabledInternal(disabled);
    }

    setFocus():void {
        this.inputElement.focus();
    }
}